const HorizontalRule = ({ my }) => {
    const myClasses = my ? "my-2" : "";
    return (
        <div className={` w-full border-dotted border-t-8 border-neutral-500/50 ${myClasses} `}/>
    );
};

export default HorizontalRule;